import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="bg-volt px-4 py-4 sm:py-6" data-id="element-76" data-mp="1o3x1pk7r0m0y">
      <div className="mx-auto flex max-w-3xl items-start gap-3" data-id="element-77" data-mp="1o3dmib9hgbqm">
        <ShieldCheckIcon className="mt-0.5 hidden h-9 w-9 shrink-0 text-navy sm:block" aria-hidden="true" data-id="element-78" data-mp="222darht32om9" />
        <div data-id="element-79" data-mp="1x54nx3wzpweo">
          <h2 className="text-lg leading-tight text-navy sm:text-2xl" data-id="element-80" data-mp="1x2ik9fd8011q">
            YOUR PURCHASE IS 100% PROTECTED
          </h2>
          <p className="mt-1 text-[13px] font-medium leading-snug text-carbon sm:text-base" data-id="element-81" data-mp="14g65e5oygs8u">
            Explore ELECTRICAL DIAGNOSTIC PRO™ for 7 days.
          </p>
          <p className="mt-1 text-[13px] font-medium leading-snug text-carbon sm:text-base" data-id="element-82" data-mp="1j6dg1z8q16yz">
            Review the six diagnostic modules, visual maps, troubleshooting
            flows, circuit references, field resources and four professional
            bonuses.
          </p>
          <p className="mt-1 text-[13px] font-medium leading-snug text-carbon sm:text-base" data-id="element-83" data-mp="lowkl09qih1y">
            If the system isn’t right for you, contact us within 7 days for a
            full refund according to the refund terms.
          </p>
        </div>
      </div>
    </section>;
}